// removed by extract-text-webpack-plugin
module.exports = {"flex":"src-components-modules-Logos-style----logos-module---flex---1UFmy alignItems-center justifyContent-center breakPointL-display-flex breakPointL-textAlign-left","cta":"src-components-modules-Logos-style----logos-module---cta---2mOF- paddingTop-l breakPointL-paddingLeft-m breakPointL-paddingTop-0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Logos/style/logos.module.css
// module id = 254
// module chunks = 47877783677342 56719701542624 281026976107462